import { render, staticRenderFns } from "./PlanCompare.vue?vue&type=template&id=610fac58&scoped=true&lang=pug"
import script from "./PlanCompare.vue?vue&type=script&lang=js"
export * from "./PlanCompare.vue?vue&type=script&lang=js"
import style0 from "./PlanCompare.vue?vue&type=style&index=0&id=610fac58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610fac58",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,PlansTable: require('/home/docker/code/frontend/components/PlansTable.vue').default})
